import { AssetAllocationCategory } from '@/cip/_openapi/portfolio-optimizer';
import { formatPercent } from 'utils/number-formatter';
import { titleCase } from 'utils/string-utils';

/** Display order for the 6 asset-class breakdown categories. */
export const ASSET_CLASS_BREAKDOWN_CATEGORIES: AssetAllocationCategory[] = [
    AssetAllocationCategory.NET_US_BOND_RATIO,
    AssetAllocationCategory.NET_NON_US_BOND_RATIO,
    AssetAllocationCategory.NET_US_EQUITY_RATIO,
    AssetAllocationCategory.NET_NON_US_EQUITY_RATIO,
    AssetAllocationCategory.NET_OTHER_RATIO,
    AssetAllocationCategory.NET_CASH_RATIO,
];

export const getAssetAllocationCategoryLabel = (category: AssetAllocationCategory): string => {
    switch (category) {
        case AssetAllocationCategory.NET_NON_US_EQUITY_RATIO:
            return 'International Equity';
        case AssetAllocationCategory.NET_US_EQUITY_RATIO:
            return 'US Equity';
        case AssetAllocationCategory.NET_NON_US_BOND_RATIO:
            return 'International Bond';
        case AssetAllocationCategory.NET_US_BOND_RATIO:
            return 'US Bond';
        case AssetAllocationCategory.NET_CASH_RATIO:
            return 'Cash';
        case AssetAllocationCategory.NET_OTHER_RATIO:
            return 'Other';
        case AssetAllocationCategory.UNCATEGORIZED:
            return 'Uncategorized';
        default:
            return titleCase(category);
    }
};

export const formatRatio = (value: number | null | undefined): string => {
    if (value === undefined || value === null || Number.isNaN(value)) return '-';
    return formatPercent(value * 100);
};

export const SUM_TOLERANCE = 1e-6;

export const isValidOverrideSum = (sum: number): boolean => Math.abs(sum - 1) <= SUM_TOLERANCE;

// Allow leveraged/short positions, but cap each category at ±200%.
export const MIN_OVERRIDE_PERCENT = -200;
export const MAX_OVERRIDE_PERCENT = 200;

export const isValidOverridePercent = (percent: number): boolean =>
    percent >= MIN_OVERRIDE_PERCENT && percent <= MAX_OVERRIDE_PERCENT;
